import { Button, Form, Input, Select, message } from 'antd';
import axios from 'axios';
import { LoadingSpinnerComponent } from 'components';
import { CONTENT_TYPE, STATUS } from 'constants/index';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import React, { memo, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import clipTrailerService from '../../services/clipTrailerService';

dayjs.extend(utc);

const ClipTrailerDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    clipTrailerService.fetchById(Number(id)).then(library => {
      form.setFieldsValue({
        ...library,
        distributions: library.distributions?.map(d => d.content_consumer_name) || [],
        release_date_start: library.release_date_start ? dayjs(library.release_date_start) : null,
        release_date_end: library.release_date_end ? dayjs(library.release_date_end) : null,
      });
      setIsLoading(false);
    });
  }, [id]);

  return isLoading ? (
    <LoadingSpinnerComponent />
  ) : (
    <div>
      <div className="content-details-page" style={{ display: 'flex' }}>
        <div className="content-details-edit">
          <Form form={form} layout="vertical" className="content-details-form">
            <Form.Item
              label="Title"
              name="title"
              rules={[{ required: true, message: 'Please enter a title!' }]}
            >
              <Input />
            </Form.Item>
            <Form.Item label="Title En" name="title_en">
              <Input />
            </Form.Item>
            <Form.Item
              label="Slug"
              name="slug"
              rules={[{ required: true, message: 'Please enter a slug' }]}
            >
              <Input />
            </Form.Item>
            <Form.Item label="Content Type" name="content_type">
              <Select>
                {CONTENT_TYPE.map(contentType => (
                  <Select.Option key={contentType} value={contentType}>
                    {contentType}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item label="Status" name="status">
              <Select>
                {STATUS.map(status => (
                  <Select.Option key={status} value={status}>
                    {status}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="Episode Order"
              name="episode_order"
              rules={[{ required: true, message: 'Please Enter an Episode Order' }]}
            >
              <Input type="number" />
            </Form.Item>
          </Form>
        </div>
      </div>
      <Form.Item style={{ marginTop: 16, textAlign: 'center' }}>
        <Button
          type="primary"
          onClick={async () => {
            try {
              await clipTrailerService.update(Number(id), form);
              message.success('Clip Trailer updated successfully');
              window.location.reload();
            } catch (error) {
              if (axios.isAxiosError(error) && error.response?.status === 400) {
                message.error('Failed to update : ' + JSON.stringify(error.response.data));
              }
            }
          }}
        >
          Save
        </Button>
      </Form.Item>
    </div>
  );
};

export default memo(ClipTrailerDetail);
